module.exports = __webpack_public_path__ + "img/데이터랩api.0f8f1973.png";